import { useEffect, useState } from 'react';
import TabsHeader from './components/TabsHeader';
import styles from './styles.module.scss';
import { Footer } from 'components-antd';
import Icons from './icons';
import { Spinner } from 'components';
import { showErrorMessage } from 'helpers';
import { getAllPromotionsByVendor } from 'api/promos';
import PromosTable from './components/PromosTable';
import PromoModal from './components/PromoModal';
import moment from 'moment';

const Promotions = () => {
  const [tabIndex, setTabIndex] = useState<number>(0);
  const [allPromos, setAllPromos] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [targetPromo, setTargetPromo] = useState<any>(undefined);

  useEffect(() => {
    fetchAllPromos();
  }, []);

  const fetchAllPromos = async () => {
    try {
      const response = await getAllPromotionsByVendor();
      if (response.status === 200 && response?.data?.result?.length)
        setAllPromos(response.data.result);
    } catch (e) {
      showErrorMessage('Unable to fetch promotions');
    }
    setLoading(false);
  };

  const handlePromoClick = (promo) => {
    if (!promo) return;

    setTargetPromo(promo);
    setShowModal(true);
  };

  const handlePromoAction = (added: boolean, promo) => {
    if (added) setAllPromos((prev) => [...prev, promo]);
    else
      setAllPromos((prev) => {
        return prev.map((original) => {
          return original.Id === promo.Id ? promo : original;
        });
      });
  };

  const isPromoValid = (dateString: string): boolean => {
    if (!dateString) return true;

    const inputDate = moment(dateString).startOf('day');
    const today = moment().startOf('day');

    if (inputDate.isBefore(today)) return false;

    return true;
  };

  return (
    <div className={styles.promotions}>
      <div className={styles.pageHeader}>
        <div className={styles.header}>
          <div></div>
          <div className={styles.heading}>Promos</div>
          <div className={styles.button} onClick={() => setShowModal(true)}>
            <Icons variant={Icons.ADD} />
            New
          </div>
        </div>
        <div className={styles.tabs}>
          <TabsHeader
            tabIndex={tabIndex}
            setTabIndex={setTabIndex}
            activeCount={
              allPromos.filter((promo) => promo.IsActive && isPromoValid(promo.ExpirationDate))
                .length
            }
            inActiveCount={
              allPromos.filter((promo) => !promo.IsActive || !isPromoValid(promo.ExpirationDate))
                .length
            }
          />
        </div>
      </div>
      <div className={styles.content}>
        {loading ? (
          <Spinner />
        ) : (
          <PromosTable
            active={tabIndex === 0}
            handlePromoClick={handlePromoClick}
            handlePromoAction={handlePromoAction}
            promos={
              tabIndex === 0
                ? allPromos.filter((promo) => promo.IsActive && isPromoValid(promo.ExpirationDate))
                : allPromos.filter(
                    (promo) => !promo.IsActive || !isPromoValid(promo.ExpirationDate),
                  )
            }
          />
        )}
      </div>
      <Footer />
      {showModal && (
        <PromoModal
          open={showModal}
          promo={targetPromo}
          handlePromoAction={handlePromoAction}
          handleModalClose={() => {
            setShowModal(false);
            setTargetPromo(undefined);
          }}
        />
      )}
    </div>
  );
};

export default Promotions;
